import Swiper, { Navigation, Pagination, EffectFade } from "swiper";

export default class Slider {
    constructor() {
        this.init();
    }

    init() {
        const slider = document.querySelector(".js-trailer-slider");

        if (!slider) {
            return;
        }

        Swiper.use([Navigation, Pagination, EffectFade]);

        const slideCount = slider.querySelectorAll(".swiper-slide").length;

        this.swiper = new Swiper(slider, {
            loop: false,
            speed: 600,
            slidesPerView: 1,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            effect: "fade",
            fadeEffect: {
                crossFade: false,
            },
            pagination: {
                el: ".js-trailer-pagination",
                clickable: true,
            },
        });

        slider.classList.add("-forward");

        this.slideCount = slideCount;
        this.setupManualLoop();

        this.swiper.on("slideChange", () => {        
            const direction = this.swiper.swipeDirection;
            slider.classList.toggle("-backward", direction === "prev");
            slider.classList.toggle("-forward", direction !== "prev");
        
            this.handleThumbnailFade();
        });

        this.setupSwipeLoop();
        this.initThumbnails();
    }

    setupSwipeLoop() {
        this.swiper.on('touchEnd', (swiper, event) => {
            const currentIndex = this.swiper.activeIndex;
            
            if (currentIndex === this.slideCount - 1 && this.swiper.touches.diff < -50) {
                setTimeout(() => {
                    this.swiper.slideTo(0, this.swiper.params.speed);
                }, 100);
            }
            
            if (currentIndex === 0 && this.swiper.touches.diff > 50) {
                setTimeout(() => {
                    this.swiper.slideTo(this.slideCount - 1, this.swiper.params.speed);
                }, 100);
            }
        });
    }

    initThumbnails() {
        const allOverlays = document.querySelectorAll('.video-thumbnail-overlay');

        allOverlays.forEach((overlay, index) => {
            const slideIndex = parseInt(overlay.dataset.slideIndex);

            if (slideIndex === this.swiper.activeIndex) {
                setTimeout(() => {
                    overlay.classList.add('fade-out');
                }, 500); // 動画読み込み待ち
            } else {
                overlay.classList.remove('fade-out');
            }
        });
    }

    handleThumbnailFade() {
        const allOverlays = document.querySelectorAll('.video-thumbnail-overlay');
        
        allOverlays.forEach((overlay) => {
            const slideIndex = parseInt(overlay.dataset.slideIndex);
            
            if (slideIndex === this.swiper.activeIndex) {
                setTimeout(() => {
                    overlay.classList.add('fade-out');
                }, 800); // スライド切り替え後に実行
            } else {
                overlay.classList.remove('fade-out');
            }
        });
    }

    setupManualLoop() {
        console.log('手動ループ機能を設定中...');

        const nextButton = document.querySelector('.js-trailer-next');
        const prevButton = document.querySelector('.js-trailer-prev');

        if (nextButton) {
            nextButton.onclick = (e) => {
                e.preventDefault();

                const currentIndex = this.swiper.activeIndex;
                let nextIndex;

                if (currentIndex >= this.slideCount - 1) {
                    nextIndex = 0; // 最後なら最初に戻る
                } else {
                    nextIndex = currentIndex + 1; // 通常の次
                }

                this.swiper.slideTo(nextIndex, this.swiper.params.speed);
            };
        }

        if (prevButton) {
            prevButton.onclick = (e) => {
                e.preventDefault();

                const currentIndex = this.swiper.activeIndex;
                let prevIndex;

                if (currentIndex <= 0) {
                    prevIndex = this.slideCount - 1; // 最初なら最後に
                } else {
                    prevIndex = currentIndex - 1; // 通常の前
                }

                this.swiper.slideTo(prevIndex, this.swiper.params.speed);
            };
        }
    }
}